import { withErrors } from "ra-remote-validator";
import React from "react";
import { Edit as RaEdit, useNotify } from "react-admin";
import { compose } from "recompose";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import Form from "./Form";
import Toolbar from "./Toolbar";

const Edit = ({ dispatch, validate, errors, permissions, ...props }) => {
	const classes = useFormStyles();
	const notify = useNotify();
	const onSuccess = (data) => {
		notify("ra.notification.updated", "info", { smart_count: 1 });
	};
	return (
		<RaEdit
			{...props}
			classes={classes}
			title={<Title source="email" />}
			mutationMode="pessimistic"
			onSuccess={onSuccess}
		>
			<Form
				permissions={permissions}
				dispatch={dispatch}
				validate={validate}
				errors={errors}
				toolbar={<Toolbar permissions={permissions} />}
			/>
		</RaEdit>
	);
};
export default compose(withErrors)(Edit);
